import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

import { FormData, UseCreateAndEditSellTreezModalProps } from '../data/types'
import { schema } from '../data/schema'

export const useCreateAndEditSellTreezModal = ({
  sellTreez,
}: UseCreateAndEditSellTreezModalProps) => {
  const {
    register,
    control,
    watch,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<FormData>({
    defaultValues: {
      name: '',
      domain: { name: '', enableCustomDomain: false },
      description: '',
      opensearch: {
        instanceType: '',
        dataNodes: 0,
        volumeSize: 0,
      },
      events: {
        source: '',
        detailType: '',
        externalAccountId: '',
      },
    },
    mode: 'onChange',
    resolver: yupResolver(schema),
  })

  useEffect(() => {
    if (sellTreez) {
      setValue('name', sellTreez.name)
      setValue('domain', {
        name: sellTreez.domain.name ?? '',
        enableCustomDomain: sellTreez.domain.enableCustomDomain ?? false,
      })
      setValue('description', sellTreez.description)
      setValue('opensearch', {
        instanceType: sellTreez.opensearch.instanceType ?? '',
        dataNodes: sellTreez.opensearch.dataNodes ?? 0,
        volumeSize: sellTreez.opensearch.volumeSize ?? 0,
      })
      setValue('events', {
        source: JSON.stringify(sellTreez.events.source ?? ''),
        detailType: JSON.stringify(sellTreez.events.detailType ?? ''),
        externalAccountId: JSON.stringify(sellTreez.events.externalAccountId ?? ''),
      })
    }
  }, [sellTreez])

  const isDisabledButton =
    !watch().name ||
    !watch().domain.name ||
    !watch().description ||
    !watch().opensearch.instanceType ||
    !watch().opensearch.dataNodes ||
    !watch().opensearch.volumeSize ||
    !watch().events.detailType ||
    !watch().events.externalAccountId ||
    !watch().events.source ||
    !!Object.keys(errors).length

  return {
    handleSubmit,
    errors,
    isDisabledButton,
    register,
    control,
  }
}
